export default function VPNShowcase() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="vpn" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-4 mb-20">
          <h2 className="text-6xl font-light text-gray-900">Our VPN Solution</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Enterprise-grade security meets user-friendly design. Experience the perfect balance of protection and performance.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-cyan-400 to-purple-600 rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition duration-500"></div>
            
            <div className="relative bg-gradient-to-br from-cyan-50 to-purple-50 rounded-3xl shadow-2xl overflow-hidden">
              <div className="p-8">
                <div className="aspect-video rounded-2xl overflow-hidden mb-8 bg-white shadow-lg">
                  <img
                    src="https://public.readdy.ai/ai/img_res/53dee8ce8821212eb74938cc052c8ab6.jpg"
                    alt="ECJL VPN Interface"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="text-center mb-8">
                  <h3 className="text-4xl font-bold text-gray-900 mb-2">ECJL VPN</h3>
                  <p className="text-lg text-gray-600">Your Gateway to Secure Internet</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                  <div className="flex items-start space-x-3 bg-white p-4 rounded-xl">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i className="ri-shield-check-line text-xl text-cyan-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-base">Military-Grade Encryption</h4>
                      <p className="text-sm text-gray-600">AES-256 encryption protects your data</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 bg-white p-4 rounded-xl">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i className="ri-speed-line text-xl text-cyan-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-base">Lightning Fast Servers</h4>
                      <p className="text-sm text-gray-600">Optimized for speed and reliability</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 bg-white p-4 rounded-xl">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i className="ri-global-line text-xl text-cyan-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-base">Global Server Network</h4>
                      <p className="text-sm text-gray-600">Connect from anywhere in the world</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3 bg-white p-4 rounded-xl">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <i className="ri-eye-off-line text-xl text-cyan-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 text-base">No-Logs Policy</h4>
                      <p className="text-sm text-gray-600">Your privacy is our top priority</p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={scrollToContact}
                  className="w-full py-4 bg-gradient-to-r from-slate-900 to-slate-800 text-white text-lg font-semibold rounded-xl hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
